'use client'

import { BridgePage } from '@/containers/Bridge'

export default function Page() {
  return <BridgePage />
}
